import { isMobilePhone, isPhoneNumber } from 'class-validator';
import * as yup from 'yup';
type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialUserFormDetails = {
  firstname: undefined,
  lastname: undefined,
  email: undefined,
  mobilePhone: undefined,
  phone: undefined,
};

export const userFormDetailsSchema = (translate: TFunction) => {
  return yup.object().shape({
    firstname: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      }),
    lastname: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      }),

    email: yup
      .string()
      .email(translate('INVALID_EMAIL_FORMAT') ?? undefined)
      .required(translate('REQUIRED') ?? undefined),
    mobilePhone: yup
      .string()
      .optional()
      .nullable()
      .test(
        'INAVLID_PHONE_NUMBER',
        translate('INAVLID_PHONE_NUMBER'),
        (value) => {
          // Use a custom test to check if the value contains only spaces
          if (value === undefined) return true;

          if (!value) return true;
          return isMobilePhone(value);
        },
      ),
    phone: yup
      .string()
      .optional()
      .nullable()
      .test(
        'INAVLID_PHONE_NUMBER',
        translate('INAVLID_PHONE_NUMBER'),
        (value) => {
          // Use a custom test to check if the value contains only spaces
          if (value === undefined) return true;

          if (!value) return true;
          return isPhoneNumber(value);
        },
      ),
  });
};
